
import type { Service } from '../types/cart';

export const servicesData: Service[] = [
  {
    id: 'general-checkup',
    name: 'General Checkup',
    category: 'Preventive',
    price: 89,
    description: 'Comprehensive oral examination to assess your dental health and identify any potential issues early.',
    duration: '30 minutes',
    included: ['Visual examination', 'Oral cancer screening', 'Gum health assessment', 'Treatment recommendations'],
  },
  {
    id: 'teeth-cleaning',
    name: 'Professional Teeth Cleaning',
    category: 'Preventive',
    price: 125,
    description: 'Deep cleaning to remove plaque, tartar, and stains, leaving your teeth fresh and healthy.',
    duration: '45 minutes',
    included: ['Plaque removal', 'Tartar removal', 'Polishing', 'Fluoride treatment'],
  },
  {
    id: 'teeth-whitening',
    name: 'Teeth Whitening',
    category: 'Cosmetic',
    price: 399,
    description: 'Professional whitening treatment to brighten your smile by several shades in just one visit.',
    duration: '60 minutes',
    included: ['Custom whitening trays', 'Professional-grade gel', 'Before/after photos', 'Touch-up kit'],
  },
  {
    id: 'dental-filling',
    name: 'Dental Filling',
    category: 'Restorative',
    price: 175,
    description: 'Tooth-colored composite fillings to restore cavities and maintain natural appearance.',
    duration: '45 minutes',
    included: ['Local anesthesia', 'Cavity preparation', 'Composite filling', 'Bite adjustment'],
  },
  {
    id: 'root-canal',
    name: 'Root Canal Therapy',
    category: 'Restorative',
    price: 895,
    description: 'Advanced treatment to save infected teeth and eliminate pain while preserving your natural tooth.',
    duration: '90 minutes',
    included: ['Digital X-rays', 'Local anesthesia', 'Root canal procedure', 'Temporary filling'],
  },
  {
    id: 'dental-crown',
    name: 'Dental Crown',
    category: 'Restorative',
    price: 1250,
    description: 'Custom-made porcelain crown to restore damaged teeth with natural-looking results.',
    duration: '2 visits',
    included: ['Tooth preparation', 'Digital impressions', 'Temporary crown', 'Permanent crown placement'],
  },
  {
    id: 'dental-implant',
    name: 'Dental Implant',
    category: 'Restorative',
    price: 3200,
    description: 'Permanent tooth replacement solution with titanium implant and custom crown.',
    duration: 'Multiple visits',
    included: ['Consultation & planning', 'Implant placement', 'Healing abutment', 'Custom crown'],
  },
  {
    id: 'orthodontic-consultation',
    name: 'Orthodontic Consultation',
    category: 'Orthodontic',
    price: 0,
    description: 'Free comprehensive evaluation to determine the best orthodontic treatment for your needs.',
    duration: '45 minutes',
    included: ['Oral examination', 'Digital X-rays', 'Treatment options', 'Cost estimate'],
  },
  {
    id: 'braces',
    name: 'Traditional Braces',
    category: 'Orthodontic',
    price: 4500,
    description: 'Metal braces to straighten teeth and correct bite issues with proven results.',
    duration: '18-24 months',
    included: ['Initial placement', 'Monthly adjustments', 'Retainers', 'Progress monitoring'],
  },
  {
    id: 'invisalign',
    name: 'Invisalign Clear Aligners',
    category: 'Orthodontic',
    price: 5500,
    description: 'Nearly invisible aligners to straighten teeth discreetly without metal brackets.',
    duration: '12-18 months',
    included: ['Custom aligners', 'Progress tracking', 'Refinements', 'Retainers'],
  },
  {
    id: 'veneers',
    name: 'Porcelain Veneers',
    category: 'Cosmetic',
    price: 1200,
    description: 'Ultra-thin porcelain shells to transform your smile with a natural, beautiful appearance.',
    duration: '2 visits',
    included: ['Consultation', 'Tooth preparation', 'Custom veneers', 'Bonding procedure'],
  },
  {
    id: 'dental-bonding',
    name: 'Dental Bonding',
    category: 'Cosmetic',
    price: 295,
    description: 'Quick cosmetic fix for chipped, cracked, or discolored teeth using tooth-colored resin.',
    duration: '30 minutes',
    included: ['Tooth preparation', 'Resin application', 'Shaping & polishing', 'Color matching'],
  },
  {
    id: 'gum-treatment',
    name: 'Gum Disease Treatment',
    category: 'Periodontal',
    price: 650,
    description: 'Deep cleaning and scaling to treat gum disease and restore gum health.',
    duration: '2 hours',
    included: ['Scaling & root planing', 'Antibiotic treatment', 'Follow-up care', 'Home care instructions'],
  },
  {
    id: 'tooth-extraction',
    name: 'Tooth Extraction',
    category: 'Surgical',
    price: 225,
    description: 'Safe and comfortable tooth removal when necessary, with proper aftercare guidance.',
    duration: '30 minutes',
    included: ['Local anesthesia', 'Extraction procedure', 'Gauze & instructions', 'Follow-up check'],
  },
  {
    id: 'wisdom-teeth',
    name: 'Wisdom Teeth Removal',
    category: 'Surgical',
    price: 450,
    description: 'Surgical removal of wisdom teeth to prevent complications and maintain oral health.',
    duration: '60 minutes',
    included: ['Sedation options', 'Surgical extraction', 'Post-op medications', 'Recovery instructions'],
  },
  {
    id: 'emergency-care',
    name: 'Emergency Dental Care',
    category: 'Emergency',
    price: 150,
    description: 'Immediate care for dental emergencies including severe pain, trauma, or infections.',
    duration: 'Varies',
    included: ['Emergency examination', 'Pain relief', 'Temporary treatment', 'Follow-up plan'],
  },
  {
    id: 'pediatric-checkup',
    name: 'Pediatric Checkup',
    category: 'Pediatric',
    price: 75,
    description: 'Gentle dental examination for children in a friendly, comfortable environment.',
    duration: '30 minutes',
    included: ['Child-friendly exam', 'Fluoride treatment', 'Oral hygiene education', 'Parent consultation'],
  },
  {
    id: 'sealants',
    name: 'Dental Sealants',
    category: 'Pediatric',
    price: 45,
    description: 'Protective coating for children\'s teeth to prevent cavities in hard-to-reach areas.',
    duration: '20 minutes',
    included: ['Tooth cleaning', 'Sealant application', 'Curing', 'Bite check'],
  },
  {
    id: 'night-guard',
    name: 'Custom Night Guard',
    category: 'Preventive',
    price: 425,
    description: 'Custom-fitted night guard to protect teeth from grinding and clenching during sleep.',
    duration: '2 visits',
    included: ['Impressions', 'Custom fabrication', 'Fitting & adjustments', 'Care instructions'],
  },
  {
    id: 'dentures',
    name: 'Complete Dentures',
    category: 'Restorative',
    price: 2400,
    description: 'Full set of custom dentures to restore function and appearance for missing teeth.',
    duration: 'Multiple visits',
    included: ['Impressions', 'Custom fabrication', 'Fitting & adjustments', 'Follow-up care'],
  },
  {
    id: 'fluoride-treatment',
    name: 'Fluoride Treatment',
    category: 'Preventive',
    price: 30,
    description: 'Professional fluoride application to strengthen enamel and protect against cavities.',
    duration: '15 minutes',
    included: ['Teeth cleaning prep', 'Fluoride application', 'Enamel strengthening', 'Aftercare guidance'],
  },
];
